"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var DataItem_1 = require("./common/base/DataItem");
var Field_1 = require("../constants/Field");
var Types_1 = require("../api/Types");
var ObjectType_1 = require("./objects/ObjectType");
var DeepCopy_1 = require("./common/lib/DeepCopy");
var lodash_1 = require("lodash");
var ModelBase = /** @class */ (function () {
    function ModelBase(model, typeId, version) {
        this.model = model;
        this.typeId = typeId;
        this.version = version;
    }
    ModelBase.fromJson = function (json) {
        var model = DataItem_1.DataItem.fromJson(Field_1.FIELD.MODEL, json[Field_1.FIELD.MODEL]);
        var typeId = DataItem_1.DataItem.fromJson(Field_1.FIELD.TYPEID, json[Field_1.FIELD.TYPEID]);
        var version = DataItem_1.DataItem.fromJson(Field_1.FIELD.VERSION, json[Field_1.FIELD.VERSION]);
        var modelBase = new ModelBase(model, typeId, version);
        return modelBase;
    };
    /**
     *
     * @param targetType Associated object type under which the sce-type will be created/imported
     * @param sceObjects Object Types in Sce Json which is being added under associated object type
     * @returns Sce Objects with its object details replaced with target object type.
     * The original SceObjects json will not be mutated
     */
    ModelBase.replaceType = function (targetType, sceObjects) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sourceType, types, response, objectType;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sourceType = DeepCopy_1.deepCopy(sceObjects);
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getTenantBasedTypeDetails(targetType.model.value, targetType.typeId.value, targetType.version.value)];
                    case 1:
                        response = _a.sent();
                        objectType = ObjectType_1.ObjectType.fromJson(response.data);
                        lodash_1.map(Object.keys(sceObjects), function (objectGuid) {
                            sourceType[objectGuid].objectTypeModel.value = objectType.model;
                            sourceType[objectGuid].objectType.value = objectType.typeId + "@" + objectType.version.split('.')[0];
                            sourceType[objectGuid].name.value = objectType.name;
                            sourceType[objectGuid].version.value = objectType.version;
                            if (objectType.variables) {
                                sourceType[objectGuid].variables = objectType.variables.toJson(objectGuid);
                            }
                            else {
                                sourceType[objectGuid].variables = {};
                            }
                        });
                        return [2 /*return*/, sourceType];
                }
            });
        });
    };
    ModelBase.prototype.toJson = function () {
        var json = Object.create(null);
        json[Field_1.FIELD.MODEL] = this.model.toJson(false);
        json[Field_1.FIELD.TYPEID] = this.typeId.toJson(false);
        json[Field_1.FIELD.VERSION] = this.version.toJson(false);
        return json;
    };
    ModelBase.prototype.isAlike = function (associatedObjectType) {
        if ((this.model.value === associatedObjectType.model.value) &&
            (this.typeId.value === associatedObjectType.typeId.value) &&
            (this.version.value === associatedObjectType.version.value)) {
            return true;
        }
        return false;
    };
    ModelBase.prototype.fetchAssociatedObjectType = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, response, objectType;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getTenantBasedTypeDetails(this.model.value, this.typeId.value, this.version.value)];
                    case 1:
                        response = _a.sent();
                        objectType = ObjectType_1.ObjectType.fromJson(response.data);
                        return [2 /*return*/, objectType];
                }
            });
        });
    };
    return ModelBase;
}());
exports.ModelBase = ModelBase;
//# sourceMappingURL=ModelBase.js.map